var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2048 19H8.798L8.14101 17.0542L6.32638 16.3028L4.48758 17.2152L2.78506 15.5119L3.69688 13.6741L2.94577 11.8591L1 11.205V8.79503L2.94577 8.14086L3.69713 6.32646L2.7848 4.48763L4.48784 2.78457L6.32587 3.69691L8.1405 2.94554L8.798 1H11.2048L11.859 2.9458L13.6734 3.69717L15.5122 2.78483L17.2152 4.48789L16.3029 6.32594L17.0542 8.14034L19 8.79451V11.2045L17.0542 11.8586L16.3029 13.673L17.2149 15.5124L15.5119 17.2154L13.6739 16.3031L11.8595 17.0545L11.2048 19Z",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99933 13C9.40622 12.9999 8.82645 12.8239 8.33329 12.4944C7.83994 12.1648 7.45543 11.6962 7.22836 11.1481C7.0013 10.5999 6.94189 9.99667 7.05765 9.41473C7.1734 8.83279 7.45912 8.29824 7.87868 7.87868C8.29824 7.45912 8.83279 7.1734 9.41473 7.05765C9.99667 6.94189 10.5999 7.0013 11.1481 7.22836C11.6962 7.45543 12.1648 7.83994 12.4944 8.33329C12.8239 8.82645 12.9999 9.40622 13 9.99933C12.999 10.7948 12.6825 11.5575 12.12 12.12C11.5575 12.6825 10.7948 12.999 9.99933 13Z",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting_icon.65eeaaa7.svg";
export { ForwardRef as ReactComponent };